import { useCallback } from "react";
import { useLightboxContext } from "@sphtech/idpf-lightbox-react";

const useGetAccessToken = () => {
  const { lightbox } = useLightboxContext();

  const getAccessToken = useCallback(async () => {
    if (!lightbox) return;

    const token = await lightbox.getAccessToken();

    return token?.accessToken;
  }, [lightbox]);

  return getAccessToken;
};

export default useGetAccessToken;
